const main = () => {
    if(!document.querySelector('#page-privacy')) return
}

export default main